module.exports = __webpack_public_path__ + "img/vbanner.e424a946.jpg";